import axiosInstance from '../../../../../services/axios/axios';

/**
 * Fetch Premier Partner Groups
 */
export const GetPremierPartnerGroups = async () => {
	const response = await axiosInstance.get(
		'api/Applications/HealthPlanET/PremierPartnerGroups'
	);

	return response.data;
};

/**
 * Fetch subgroups based on premier partner group value
 * @param premierPartnerGroup string
 */
export const GetSubGroups = async premierPartnerGroup => {
	const response = await axiosInstance.get(
		`api/Applications/HealthPlanET/SubGroups?premierPartnerGroup=${premierPartnerGroup}`
	);

	return response.data;
};

/**
 * Fetch sites based on premier partner group value
 * @param premierPartnerGroup string
 */
export const GetSites = async premierPartnerGroup => {
	const response = await axiosInstance.get(
		`api/Applications/HealthPlanET/Sites?premierPartnerGroup=${premierPartnerGroup}`
	);

	return response.data;
};
